import { withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BlacklistBase } from './Blacklist'

import { blacklistBookingsSelector, isLoadingSelector } from 'reduxModules/selectors/BlacklistSelectors'
import { blacklistActions } from 'reduxModules/actions/BlacklistActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector,
  blacklistBookings: blacklistBookingsSelector
})

const mapDispatchToProps = {
  getBlacklistBookings: blacklistActions.getBlacklistBookings
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Blacklist = enhance(BlacklistBase)



// WEBPACK FOOTER //
// ./src/components/Blacklist/index.js